import { Box, Grid, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import React, { useRef, useEffect, useState } from "react";
import { formatTitle } from "./ParcelsHandled";
import { useParcels } from "../../../services/clear-customs/overall";

export function ClearCustomsFilter() {
  const { parcelsHandled } = useParcels();
  const sentinelRef = useRef(null);
  const wrapperRef = useRef(null);
  const isStickyRef = useRef(false);
  const [isSticky, setIsSticky] = useState(false);
  const [stickyDimensions, setStickyDimensions] = useState({ left: 0, width: "100%" });
  const [placeholderHeight, setPlaceholderHeight] = useState(0);

  useEffect(() => {
    const scrollEl = document.querySelector(".simplebar-content-wrapper");
    if (!scrollEl) return;

    const handleScroll = () => {
      if (!sentinelRef.current || !wrapperRef.current) return;
      const shouldBeSticky = sentinelRef.current.getBoundingClientRect().top < -15;

      if (shouldBeSticky !== isStickyRef.current) {
        if (shouldBeSticky) {
          const rect = wrapperRef.current.getBoundingClientRect();
          setStickyDimensions({ left: rect.left, width: rect.width });
          setPlaceholderHeight(rect.height);
        }
        isStickyRef.current = shouldBeSticky;
        setIsSticky(shouldBeSticky);
      }
    };

    scrollEl.addEventListener("scroll", handleScroll, { passive: true });
    return () => scrollEl.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <div ref={sentinelRef} />
      {isSticky && <div style={{ height: placeholderHeight }} />}
      <Box
        ref={wrapperRef}
        sx={{
          marginRight: "45px",
          borderRadius: "8px",
          boxShadow: "0 2px 4px -2px var(--10), 0 4px 6px -1px var(--10)",
          border: "solid 1px var(--new-border)",
          backgroundColor: "var(--app-body)",
          ...(isSticky && {
            position: "fixed",
            top: 0,
            left: stickyDimensions.left,
            width: stickyDimensions.width,
            zIndex: 1000,
          }),
        }}
        data-testid="time_period_box"
      >
      {Array.isArray(parcelsHandled) && parcelsHandled.length > 0 &&
        <Box
          sx={{
            height: "48px",
            flexGrow: 0,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 16px",
            borderBottom: "solid 1px var(--new-border)"
          }}
        >
          <Typography
            color={"var(--text-primary)"}
            variant="subtitle1"
            fontWeight={600}
            fontSize={"20px"}
            data-testid="time_period_heading"
            sx={{
              height: "28px",
              flexGrow: 1,
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "8px",
              padding: 0
            }}
          >
            <FormattedMessage id="timePeriod" />
          </Typography>
        </Box>
      }
      <Grid container>
        {parcelsHandled?.map?.((tp, index) => (
          <Grid key={index} item xs={12} sm={6} md={3} lg={3}>
            <Box
              sx={{
                textAlign: "center",
                fontWeight: 600,
                fontSize: "20px",
                color: "var(--text-primary)",
                borderBottom: "solid 2px var(--new-border-accent)",
                py: 2
              }}
              data-testid={`time_period_value_${tp.type}`}
            >
              {formatTitle(tp)}
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
    </>
  );
}
